import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

export const apiRequest = async (url, options = {}, errorMessage = 'Ошибка запроса') => {
  const fullUrl = url.startsWith('http') ? url : `${backendUrl}${url}`;
  const isFormData = options.body instanceof FormData;

  const defaultOptions = {
    ...(!isFormData && { headers: { 'Content-Type': 'application/json' } }),
    ...options,
  };

  const response = await fetchWithAuth(fullUrl, defaultOptions);
  if (!response.ok) {
    throw new Error(`${errorMessage}: ${response.status}`);
  }
  
  return response.status !== 204 ? response.json() : response;
};